(function(){
/* ============================================================
   AUREA® · PDP estilo Seed — App (React + Babel)
   Placeholders etiquetados (image-slot rellenables).
   ============================================================ */

/* --- viewport guard: repara el meta si la plantilla lo perdió/duplicó --- */
(function () {
  try {
    var metas = document.querySelectorAll('meta[name=viewport]');
    var m = metas[0];
    for (var i = 1; i < metas.length; i++) metas[i].parentNode.removeChild(metas[i]);
    if (!m) {
      m = document.createElement('meta');
      m.setAttribute('name', 'viewport');
      document.head.appendChild(m);
    }
    m.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover');
  } catch (e) {}
})();
function Ph({
  id,
  label,
  cls = '',
  video = false,
  dark = false
}) {
  return /*#__PURE__*/React.createElement("image-slot", {
    id: id,
    class: 'pdp-ph ' + (video ? 'video ' : '') + (dark ? 'on-dark ' : '') + cls,
    shape: "rect",
    fit: "cover",
    placeholder: label
  });
}

/* --- datos --- */
const PILLARS = [{
  t: 'Diversidad probiótica',
  d: '14 cepas vivas que acompañan la diversidad de tu microbiota, la base de una buena digestión.'
}, {
  t: 'Una sola porción, 20 activos',
  d: 'Probióticos, adaptógenos, superfoods, antioxidantes y vitaminas —seleccionados por su potencia, absorción y sinergia— en un solo batido diario.'
}, {
  t: 'Fibra que alimenta tu microbiota',
  d: 'La inulina (1.000 mg) y la fibra de bambú (700 mg) funcionan como prebiótico: alimentan a las bacterias beneficiosas de tu intestino.'
}, {
  t: 'Respaldado por la ciencia de sus ingredientes',
  d: 'Activos con evidencia a nivel de ingrediente, como el betaglucano y la astaxantina.'
}];
const TIMELINE = [{
  pill: 'DÍA 1',
  t: 'El primer paso se siente',
  items: ['Tu cuerpo recibe 20 activos trabajando desde la primera toma', 'Un ritual simple que marca el inicio de algo tuyo', 'La sensación de estar haciendo algo bien por ti']
}, {
  pill: '7 DÍAS',
  t: 'Tu digestión encuentra su ritmo',
  items: ['Acompañas tu tránsito y tu comodidad, día tras día', 'Ese peso de después de comer, más liviano', 'Tu intestino deja de ser algo en lo que piensas']
}, {
  pill: '4 SEMANAS',
  t: 'La energía que no se apaga a media tarde',
  items: ['Foco y claridad que te acompañan de la mañana a la noche', 'El eje intestino–mente jugando a tu favor', 'Y en medio del caos, una calma que reconoces']
}, {
  pill: '+12 SEMANAS',
  t: 'Ya no es un producto. Es tu rutina',
  items: ['Tus defensas y tu piel, cuidadas desde adentro', 'Bienestar que dejó de ser esfuerzo y se volvió hábito', 'La mejor versión de ti, sostenida en el tiempo']
}];
const BLENDS = [{
  b: 'Blend probiótico',
  d: '14 cepas vivas seleccionadas',
  key: '≈1,47 × 10¹⁰ UFC',
  detail: 'Lactobacillus plantarum, L. acidophilus, L. casei, L. johnsonii, L. rhamnosus, L. paracasei, L. bulgaricus, L. salivarius, Bifidobacterium longum, B. lactis, B. breve, B. bifidum, Bacillus coagulans y B. subtilis.'
}, {
  b: 'Blend de hongos',
  d: 'Hongos funcionales adaptógenos',
  key: '400 mg',
  detail: 'Reishi (135 mg) · Cordyceps militaris (135 mg) · Melena de león (130 mg).'
}, {
  b: 'Greens & superfoods',
  d: 'Verde real, no solo fibra',
  key: '2.300 mg',
  detail: 'Kale (550 mg) · Espinaca (550 mg) · Chlorella (550 mg) · Spirulina (550 mg) · Té matcha (100 mg).'
}, {
  b: 'Antioxidantes',
  d: 'Frente al estrés oxidativo',
  key: '1.252 mg',
  detail: 'Semilla de uva (500 mg) · Maqui (400 mg) · Camu camu (200 mg) · Vitamina C (150 mg · 250% DDR) · Astaxantina (2 mg).'
}, {
  b: 'Defensa & fibra',
  d: 'Betaglucano + prebióticos',
  key: '1.950 mg',
  detail: 'Inulina (1.000 mg) · Fibra de bambú (700 mg) · Betaglucano (250 mg).'
}, {
  b: 'Otros activos',
  d: 'Complemento funcional',
  key: '700 mg',
  detail: 'Zanahoria (300 mg) · Jengibre (300 mg) · Lecitina de maravilla (100 mg).'
}];
const SEALS = [{
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/HACCP_GMP.png?v=1784128786',
  t: 'HACCP / GMP'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/FORMULADO_EN_CHILE.png?v=1784128786',
  t: 'Formulado en Chile'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/14_CEPAS_PROBIOTICAS.png?v=1784128786',
  t: '14 cepas probióticas'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/VITAMINA_C.png?v=1784128786',
  t: 'Alto aporte de Vitamina C'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/SIN_AZUCAR_ANADIDA.png?v=1784128786',
  t: 'Sin azúcar añadida'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/SIN_CONSERVANTES.png?v=1784128786',
  t: 'Sin conservantes'
}];
const COMPARE = [{
  t: '14 cepas probióticas vivas',
  o: '10 cepas o menos'
}, {
  t: 'Adaptógenos',
  o: 'Solo 1'
}, {
  t: 'Betaglucano',
  o: '—'
}, {
  t: 'Astaxantina',
  o: '—'
}, {
  t: 'Greens reales',
  o: 'yes'
}, {
  t: 'Vitamina C',
  o: '—'
}, {
  t: 'Sin azúcar añadida',
  o: '—'
}];
const TESTING = [{
  t: 'Elaborado bajo HACCP / GMP',
  d: 'Protocolos de calidad en cada etapa de producción.'
}, {
  t: 'Formulado y envasado en Chile',
  d: 'Res. SEREMI R.M. de Salud N°1613366774.'
}, {
  t: 'Control microbiológico por lote',
  d: 'Aerobios, hongos, levaduras, S. aureus y salmonella.'
}, {
  t: 'Análisis de laboratorio externo',
  d: 'Composición nutricional verificada por QLF Labs, laboratorio con acreditación internacional ILAC/ANAB.'
}];
const FAQS = [{
  q: '¿Cómo tomo el Batido AUREA®?',
  a: 'Disuelve una porción (1 scoop, 7,79 g) en 200 ml de agua y mezcla 15–20 segundos. Puedes tomarlo con o sin alimentos, en el momento del día que mejor se acomode a tu rutina. La constancia diaria es lo que hace la diferencia. Recomendación máxima: una porción al día.'
}, {
  q: '¿Por qué debería tomar AUREA®?',
  a: 'Tu microbioma —la comunidad de microorganismos que habita tu intestino— participa en tu digestión, tu equilibrio y la síntesis de nutrientes. Una sola porción de AUREA® suma 14 cepas probióticas (≈1,47 × 10¹⁰ UFC), fibra prebiótica, superfoods y antioxidantes a tu día, en un formato simple de sostener en el tiempo.'
}, {
  q: '¿Qué contiene una porción?',
  a: '20 activos, entre ellos 14 cepas probióticas, blend de hongos (reishi, cordyceps, melena de león), greens (kale, espinaca, chlorella, spirulina, matcha), antioxidantes (maqui, semilla de uva, astaxantina, camu camu) y Vitamina C que aporta el 250% de la dosis diaria recomendada. Sabor maracuyá-piña, endulzado solo con stevia.'
}, {
  q: '¿Puedo cancelar cuando quiera?',
  a: 'Sí. La suscripción es flexible: pausas o cancelas cuando quieras, sin costos ocultos.'
}, {
  q: '¿Quiénes no deberían consumirlo?',
  a: 'No se recomienda su consumo por menores de 8 años, embarazadas ni nodrizas, salvo indicación de un profesional competente. No reemplaza a una alimentación balanceada.'
}];
function Acc({
  items,
  cls,
  qCls,
  aCls,
  itemCls
}) {
  const [open, setOpen] = React.useState(-1);
  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, items.map((it, i) => {
    const isOpen = open === i;
    return /*#__PURE__*/React.createElement("div", {
      className: itemCls + (isOpen ? ' open' : ''),
      key: i
    }, /*#__PURE__*/React.createElement("button", {
      className: qCls,
      "aria-expanded": isOpen,
      onClick: () => setOpen(isOpen ? -1 : i)
    }, it.q, /*#__PURE__*/React.createElement("span", {
      className: "pm"
    })), /*#__PURE__*/React.createElement("div", {
      className: aCls,
      style: {
        maxHeight: isOpen ? '360px' : '0'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: aCls + '-in'
    }, it.a)));
  }));
}

/* --- Countdown (próximas 9:00 am hora Chile) --- */
function LdCountdown() {
  const [rem, setRem] = React.useState(null);
  React.useEffect(() => {
    function calc() {
      const fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Santiago', hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      const p = {};
      fmt.formatToParts(new Date()).forEach(x => { p[x.type] = x.value; });
      const cur = (+p.hour) * 3600 + (+p.minute) * 60 + (+p.second);
      let r = 9 * 3600 - cur;
      if (r <= 0) r += 86400;
      setRem(r);
    }
    calc();
    const id = setInterval(calc, 1000);
    return () => clearInterval(id);
  }, []);
  if (rem == null) return null;
  const h = String(Math.floor(rem / 3600)).padStart(2, '0');
  const m = String(Math.floor(rem % 3600 / 60)).padStart(2, '0');
  const s = String(rem % 60).padStart(2, '0');
  return /*#__PURE__*/React.createElement("span", { className: "pdp-cd" },
    /*#__PURE__*/React.createElement("span", { className: "pdp-cd-seg" }, /*#__PURE__*/React.createElement("b", null, h), /*#__PURE__*/React.createElement("i", null, "HRS")),
    /*#__PURE__*/React.createElement("span", { className: "pdp-cd-sep" }, ":"),
    /*#__PURE__*/React.createElement("span", { className: "pdp-cd-seg" }, /*#__PURE__*/React.createElement("b", null, m), /*#__PURE__*/React.createElement("i", null, "MIN")),
    /*#__PURE__*/React.createElement("span", { className: "pdp-cd-sep" }, ":"),
    /*#__PURE__*/React.createElement("span", { className: "pdp-cd-seg" }, /*#__PURE__*/React.createElement("b", null, s), /*#__PURE__*/React.createElement("i", null, "SEG")));
}

/* --- Nav --- */
function PdpNav() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pdp-announce"
  }, /*#__PURE__*/React.createElement("span", { className: "pdp-announce-txt", style: { display: "flex", flexDirection: "column", alignItems: "center", lineHeight: 1.25 } }, /*#__PURE__*/React.createElement("span", { style: { fontWeight: 600 } }, "OFERTA DE BIENVENIDA - AHORRA HASTA 28%"), /*#__PURE__*/React.createElement("span", { style: { fontSize: "0.84em", fontWeight: 400, opacity: 0.92 } }, "Kit de Bienvenida Gratis + 90 d\xEDas de Garant\xEDa de Devoluci\xF3n")), " ", /*#__PURE__*/React.createElement(LdCountdown, null)), /*#__PURE__*/React.createElement("nav", {
    className: "pdp-nav"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#top",
    "aria-label": "AUREA®",
    style: {
      display: 'inline-block',
      height: '44px',
      overflow: 'visible'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/Frame_74_3.png?v=1783440776",
    alt: "AUREA®",
    style: {
      height: '44px',
      width: 'auto',
      display: 'block',
      transform: 'scale(2.2)',
      transformOrigin: 'center center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "links"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#pilares"
  }, "Beneficios"), /*#__PURE__*/React.createElement("a", {
    href: "#ciencia"
  }, "Ciencia"), /*#__PURE__*/React.createElement("a", {
    href: "#formula"
  }, "Ingredientes"))));
}

/* --- Checkout AUREA (Shopify cart/add + selling plan) --- */
var AUREA_PLANS = {
  '90':   { variantId: 53064294236449, sellingPlan: 691361186081 },
  '30':   { variantId: 53064294269217, sellingPlan: 691361153313 },
  'once': { variantId: 53064294301985, sellingPlan: null }
};
window.AUREA_SELECTED_PLAN = window.AUREA_SELECTED_PLAN || '90';
async function aureaCheckout(ev) {
  if (ev && ev.preventDefault) ev.preventDefault();
  var sel = AUREA_PLANS[window.AUREA_SELECTED_PLAN] || AUREA_PLANS['90'];
  var item = { id: sel.variantId, quantity: 1 };
  if (sel.sellingPlan) item.selling_plan = sel.sellingPlan;
  try {
    await fetch('/cart/clear.js', { method: 'POST' });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    window.location.href = '/checkout';
  } catch (e) {
    window.location.href = '/cart/' + sel.variantId + ':1';
  }
}

/* --- Hero PDP --- */
function PdpHero() {
  const [plan, setPlan] = React.useState('90');
  React.useEffect(() => { window.AUREA_SELECTED_PLAN = plan; }, [plan]);
  const gMedia = [{
    type: 'video',
    src: 'https://cdn.shopify.com/videos/c/o/v/5562b52301a94ac3be41c9f03e4f444e.mp4',
    poster: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_5_jul_2026_01_48_25_a.m..png?v=1783349712',
    alt: 'Video pote AUREA®'
  }, {
    type: 'img',
    src: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_5_jul_2026_12_17_29_a.m..png?v=1783349744',
    alt: 'Detalle scoop y polvo'
  }, {
    type: 'img',
    src: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/packaging3.png?v=1788369156',
    alt: 'Kit de bienvenida'
  }, {
    type: 'img',
    src: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_5_jul_2026_01_48_25_a.m..png?v=1783349712',
    alt: 'Pote AUREA® en escenario real'
  }, {
    type: 'img',
    src: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/informacionnutricional.png?v=1784469661',
    alt: 'Tabla de ingredientes'
  }];
  const [gActive, setGActive] = React.useState(0);
  const [gZoom, setGZoom] = React.useState(false);
  const [gPlaying, setGPlaying] = React.useState(true);
  const gVidRef = React.useRef(null);
  const gViewRef = React.useRef(null);
  const gScrollLock = React.useRef(false);
  React.useEffect(() => {
    const v = gVidRef.current;
    if (v) {
      v.muted = true;
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    }
  }, [gActive]);
  // Sync carousel scroll position when active index changes via thumbs/dots
  React.useEffect(() => {
    const vp = gViewRef.current;
    if (!vp) return;
    const slide = vp.children[gActive];
    if (!slide) return;
    gScrollLock.current = true;
    vp.scrollTo({
      left: slide.offsetLeft - vp.offsetLeft,
      behavior: 'smooth'
    });
    const t = setTimeout(() => {
      gScrollLock.current = false;
    }, 400);
    return () => clearTimeout(t);
  }, [gActive]);
  const onGScroll = React.useCallback(() => {
    if (gScrollLock.current) return;
    const vp = gViewRef.current;
    if (!vp) return;
    const center = vp.scrollLeft + vp.clientWidth / 2;
    let best = 0,
      bestD = Infinity;
    for (let i = 0; i < vp.children.length; i++) {
      const c = vp.children[i];
      const mid = c.offsetLeft - vp.offsetLeft + c.clientWidth / 2;
      const d = Math.abs(mid - center);
      if (d < bestD) {
        bestD = d;
        best = i;
      }
    }
    setGActive(prev => prev === best ? prev : best);
  }, []);
  React.useEffect(() => {
    if (!gZoom) return;
    const onKey = e => {
      if (e.key === 'Escape') setGZoom(false);
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [gZoom]);
  return /*#__PURE__*/React.createElement("header", {
    className: "pdp-hero",
    id: "top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-hero-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-gallery"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-gviewport",
    ref: gViewRef,
    onScroll: onGScroll
  }, gMedia.map((m, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: 'pdp-gslide' + (i === gActive ? ' on' : ''),
    onClick: () => setGZoom(true),
    style: {
      cursor: 'zoom-in'
    }
  }, m.type === 'video' ? /*#__PURE__*/React.createElement("video", {
    ref: i === 0 ? gVidRef : null,
    src: m.src,
    poster: m.poster,
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true
  }) : /*#__PURE__*/React.createElement("img", {
    src: m.src,
    alt: m.alt,
    style: {
      objectFit: m.fit || 'cover'
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "pdp-thumbs"
  }, gMedia.map((m, i) => /*#__PURE__*/React.createElement("button", {
    key: i,
    className: 'pdp-thumb' + (i === gActive ? ' on' : ''),
    onClick: () => setGActive(i),
    "aria-label": m.alt
  }, m.type === 'video' ? /*#__PURE__*/React.createElement("video", {
    src: m.src,
    muted: true,
    playsInline: true,
    preload: "metadata"
  }) : /*#__PURE__*/React.createElement("img", {
    src: m.src,
    alt: m.alt,
    loading: "lazy"
  }))))), gZoom && /*#__PURE__*/React.createElement("div", {
    className: "pdp-lightbox",
    onClick: () => setGZoom(false)
  }, /*#__PURE__*/React.createElement("button", {
    className: "pdp-lightbox-x",
    "aria-label": "Cerrar",
    onClick: () => setGZoom(false)
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "pdp-lightbox-stage",
    onClick: e => e.stopPropagation()
  }, gMedia[gActive].type === 'video' ? /*#__PURE__*/React.createElement("video", {
    key: gMedia[gActive].src,
    ref: el => { if (el) el.muted = true; },
    src: gMedia[gActive].src,
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true
  }) : /*#__PURE__*/React.createElement("img", {
    src: gMedia[gActive].src,
    alt: gMedia[gActive].alt
  }), /*#__PURE__*/React.createElement("div", {
    className: "pdp-lightbox-thumbs"
  }, gMedia.map((m, i) => /*#__PURE__*/React.createElement("button", {
    key: i,
    className: 'pdp-thumb' + (i === gActive ? ' on' : ''),
    onClick: () => setGActive(i),
    "aria-label": m.alt
  }, m.type === 'video' ? /*#__PURE__*/React.createElement("img", {
    src: m.poster,
    alt: m.alt
  }) : /*#__PURE__*/React.createElement("img", {
    src: m.src,
    alt: m.alt
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "pdp-buy"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-title-row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pill"
  }, "Superfood Aurea\u00AE"), /*#__PURE__*/React.createElement("h1", null, "Greens & Superfoods")), /*#__PURE__*/React.createElement("p", {
    className: "desc"
  }, "Tu batido diario con 20 activos \u201414 cepas probi\xF3ticas, adapt\xF3genos, superfoods y vitaminas\u2014 para acompa\xF1ar tu digesti\xF3n, tu energ\xEDa y tu calma desde adentro."), /*#__PURE__*/React.createElement("div", {
    className: "pdp-subs"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-subs-eyebrow"
  }, "Suscr\xEDbete y ahorra"), /*#__PURE__*/React.createElement("label", {
    className: 'pdp-plan' + (plan === '90' ? ' on' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-plan-badge"
  }, "Mejor valor"), /*#__PURE__*/React.createElement("div", {
    className: "pdp-plan-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-plan-radio"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "pdp-plan",
    checked: plan === '90',
    onChange: () => setPlan('90')
  }), /*#__PURE__*/React.createElement("span", {
    className: "dot"
  })), /*#__PURE__*/React.createElement("span", {
    className: "pdp-plan-name"
  }, "Suministro 90 d\xEDas"), /*#__PURE__*/React.createElement("span", {
    className: "pdp-plan-save"
  }, "Ahorra 28%")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-plan-price"
  }, /*#__PURE__*/React.createElement("span", {
    className: "now"
  }, "$60.881", /*#__PURE__*/React.createElement("small", null, "/mes")), /*#__PURE__*/React.createElement("span", {
    className: "was"
  }, "$83.990")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-plan-billed"
  }, /*#__PURE__*/React.createElement("span", null, "Facturado $182.643 cada 90 días"), /*#__PURE__*/React.createElement("span", {
    className: "per"
  }, "$2.029 / porci\xF3n")), plan === '90' && /*#__PURE__*/React.createElement("ul", {
    className: "pdp-plan-perks"
  }, /*#__PURE__*/React.createElement("li", null, "Kit de bienvenida gratis (Termo + Vitamina D3+K2)"), /*#__PURE__*/React.createElement("li", null, "M\xE1ximo ahorro \u2014 menor precio por porci\xF3n"), /*#__PURE__*/React.createElement("li", null, "Precio congelado de Lista Dorada"), /*#__PURE__*/React.createElement("li", null, "Cancela o pausa cuando quieras"), /*#__PURE__*/React.createElement("li", null, "Garant\xEDa de devoluci\xF3n de 90 d\xEDas"), /*#__PURE__*/React.createElement("li", null, "Env\xEDo gratis"))), /*#__PURE__*/React.createElement("label", {
    className: 'pdp-plan' + (plan === '30' ? ' on' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-plan-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-plan-radio"
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "pdp-plan",
    checked: plan === '30',
    onChange: () => setPlan('30')
  }), /*#__PURE__*/React.createElement("span", {
    className: "dot"
  })), /*#__PURE__*/React.createElement("span", {
    className: "pdp-plan-name"
  }, "Suministro 30 d\xEDas"), /*#__PURE__*/React.createElement("span", {
    className: "pdp-plan-save"
  }, "Ahorra 17%")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-plan-price"
  }, /*#__PURE__*/React.createElement("span", {
    className: "now"
  }, "$69.990", /*#__PURE__*/React.createElement("small", null, "/mes")), /*#__PURE__*/React.createElement("span", {
    className: "was"
  }, "$83.990")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-plan-billed"
  }, /*#__PURE__*/React.createElement("span", null, "Facturado $69.990 cada 30 d\xEDas"), /*#__PURE__*/React.createElement("span", {
    className: "per"
  }, "$2.333 / porci\xF3n")), plan === '30' && /*#__PURE__*/React.createElement("ul", {
    className: "pdp-plan-perks"
  }, /*#__PURE__*/React.createElement("li", null, "Kit de bienvenida gratis (Termo + Vitamina D3+K2)"), /*#__PURE__*/React.createElement("li", null, "Ahorra 17% \u2014 buen precio por porci\xF3n"), /*#__PURE__*/React.createElement("li", null, "Precio congelado de Lista Dorada"), /*#__PURE__*/React.createElement("li", null, "Cancela o pausa cuando quieras"), /*#__PURE__*/React.createElement("li", null, "Garant\xEDa de devoluci\xF3n de 90 d\xEDas"), /*#__PURE__*/React.createElement("li", null, "Env\xEDo gratis"))), /*#__PURE__*/React.createElement("button", {
    className: 'pdp-plan-once' + (plan === 'once' ? ' on' : ''),
    onClick: () => setPlan('once')
  }, "Compra \xFAnica $83.990")), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-gold btn-cta",
    href: "#",
    onClick: aureaCheckout
  }, "Empezar mi rutina"), /*#__PURE__*/React.createElement(Acc, {
    items: [{
      q: 'Beneficios',
      a: /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "Acompa\xF1a tu digesti\xF3n y tu comodidad diaria"), /*#__PURE__*/React.createElement("li", null, "Apoya tu energ\xEDa y tu claridad a lo largo del d\xEDa"), /*#__PURE__*/React.createElement("li", null, "Aporta activos para tus defensas y tu piel"), /*#__PURE__*/React.createElement("li", null, "Adapt\xF3genos para tu equilibrio y calma"))
    }, {
      q: 'Ingredientes',
      a: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
        style: {
          margin: '0 0 .6rem'
        }
      }, "20 activos en una sola porci\xF3n diaria: 14 cepas probi\xF3ticas (\u22481,47 \xD7 10\xB9\u2070 UFC), blend de hongos (reishi, cordyceps, melena de le\xF3n), greens (kale, espinaca, chlorella, spirulina, matcha), antioxidantes (maqui, semilla de uva, astaxantina, camu camu, vitamina C 250% DDR), betaglucano, inulina y fibra de bamb\xFA. Sabor maracuy\xE1-pi\xF1a. Endulzado solo con stevia."), /*#__PURE__*/React.createElement("a", {
        className: "pdp-acc-link",
        href: "/pages/ingredientes"
      }, "Ver cepas + ingredientes \u2192"))
    }],
    cls: "pdp-acc",
    itemCls: "pdp-acc-item",
    qCls: "pdp-acc-q",
    aCls: "pdp-acc-a"
  }))));
}

/* --- Pilares (oscuro) --- */
function PillarIco({
  type
}) {
  const p = {
    viewBox: '0 0 32 32',
    width: 30,
    height: 30,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.4,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  };
  switch (type) {
    case 0:
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "16",
        cy: "9",
        r: "4"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "9",
        cy: "20",
        r: "4"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "23",
        cy: "20",
        r: "4"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M16 13v3M13 18l-2 1M19 18l2 1"
      }));
    case 1:
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M7 12h18l-1.5 13a2 2 0 0 1-2 1.8H10.5a2 2 0 0 1-2-1.8z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M5 12l3-5h16l3 5"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13 17v4M19 17v4"
      }));
    case 2:
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M6 8c6 0 6 16 12 16s6-16 12-16"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M6 16c5 0 5 8 10 8",
        opacity: ".6"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "24",
        cy: "10",
        r: "1.3",
        fill: "currentColor",
        stroke: "none"
      }));
    case 3:
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M13 4v7l-5 10a2 2 0 0 0 1.8 3h12.4a2 2 0 0 0 1.8-3l-5-10V4"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M11 4h10M10 19h12"
      }));
    default:
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "16",
        cy: "16",
        r: "10"
      }));
  }
}
function PdpPillars() {
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-pillars",
    id: "pilares"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-pillars-bg"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_5_jul_2026_05_52_28_p.m..png?v=1783440557",
    alt: "",
    className: "pdp-pillars-bgimg"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-pillars-inner"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "pdp-pillars-title"
  }, "Siente la diferencia de un ", /*#__PURE__*/React.createElement("span", {
    className: "pdp-underline-gold"
  }, "intestino en equilibrio.")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-pillars-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-pillars-grid"
  }, PILLARS.map((p, i) => /*#__PURE__*/React.createElement("div", {
    className: "pdp-pillar",
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-pillar-ico"
  }, /*#__PURE__*/React.createElement("img", {
    className: "pdp-pillar-img", src: PILLAR_IMGS[i], alt: "", loading: "lazy"
  })), /*#__PURE__*/React.createElement("h3", null, p.t), /*#__PURE__*/React.createElement("p", null, p.d)))))));
}

const PILLAR_IMGS = ["https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_28_ago_2026_07_51_19_p.m..png?v=1787917910","https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_28_ago_2026_07_20_38_p.m..png?v=1787916078","https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_28_ago_2026_07_20_46_p.m..png?v=1787916083","https://cdn.shopify.com/s/files/1/0991/4302/4929/files/haccp-gmp.png?v=1787900345"];

/* --- Ciencia 1 --- */
function PdpScience() {
  const vizRef = React.useRef(null);
  React.useEffect(() => {
    const el = vizRef.current;
    if (!el) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.classList.add('is-in');
      return;
    }
    const io = new IntersectionObserver(ents => {
      ents.forEach(e => {
        el.classList.toggle('is-in', e.isIntersecting);
      });
    }, {
      threshold: 0.4
    });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-sci",
    id: "ciencia"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-sci-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-sci-img"
  }, /*#__PURE__*/React.createElement("video", {
    src: "https://cdn.shopify.com/videos/c/o/v/7474d2ceda9e410cbdd8ef21f600f0e3.mp4",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    ref: el => { if (el) el.muted = true; },
    className: "pdp-sci-fixed-img"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-sci-card",
    style: {
      '--sci-bg': "url('https://cdn.shopify.com/s/files/1/0991/4302/4929/files/termo_desktop.png?v=1784274258')",
      '--sci-bg-mobile': "url('https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_17_jul_2026_01_16_50_p.m..png?v=1784265705')"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-sci-copy"
  }, /*#__PURE__*/React.createElement("h2", null, "Una f\xF3rmula pensada para que los activos lleguen donde importan."), /*#__PURE__*/React.createElement("p", {
    className: "pdp-sci-lead"
  }, "No basta con incluir 20 activos: importa que lleguen en buen estado. Por eso combinamos 14 cepas probi\xF3ticas seleccionadas con fibra prebi\xF3tica que las acompa\xF1a, en una matriz pensada para tu rutina diaria.")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-sci-viz",
    ref: vizRef
  }, /*#__PURE__*/React.createElement("svg", {
    className: "pdp-sci-lines",
    viewBox: "0 0 548 240",
    preserveAspectRatio: "none",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "sciDot",
    markerWidth: "8",
    markerHeight: "8",
    refX: "4",
    refY: "4",
    markerUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", { cx: "4", cy: "4", r: "3.2", fill: "#D9B778" }))), /*#__PURE__*/React.createElement("path", {
    className: "pdp-sci-line l1",
    pathLength: "1",
    d: "M258,179 L308,179",
    fill: "none",
    stroke: "#D9B778",
    strokeWidth: "1.2",
    vectorEffect: "non-scaling-stroke",
    markerEnd: "url(#sciDot)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pdp-sci-line l2",
    pathLength: "1",
    d: "M410,116 L346,116",
    fill: "none",
    stroke: "#D9B778",
    strokeWidth: "1.2",
    vectorEffect: "non-scaling-stroke",
    markerEnd: "url(#sciDot)"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-sci-callout"
  }, /*#__PURE__*/React.createElement("b", null, "Fibra prebi\xF3tica"), /*#__PURE__*/React.createElement("p", null, "La inulina y la fibra", /*#__PURE__*/React.createElement("br", null), "de bamb\xFA alimentan", /*#__PURE__*/React.createElement("br", null), "a tus bacterias beneficiosas.")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-video pdp-sci-video pdp-sci-termo-slot",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pdp-sci-callout"
  }, /*#__PURE__*/React.createElement("b", null, "Cepas probi\xF3ticas"), /*#__PURE__*/React.createElement("p", null, "14 cepas vivas que se suman a la comunidad de tu microbiota."))))));
}

/* --- Beneficios en el tiempo --- */
function PdpBenefits() {
  React.useEffect(() => {
    const items = document.querySelectorAll('.pdp-tl-item');
    if (!('IntersectionObserver' in window)) {
      items.forEach(el => el.classList.add('is-on'));
      return;
    }
    const io = new IntersectionObserver(es => {
      es.forEach(e => {
        e.target.classList.toggle('is-on', e.isIntersecting);
      });
    }, {
      threshold: 0.5,
      rootMargin: '0px 0px -12% 0px'
    });
    items.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-bene"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-bene-in"
  }, /*#__PURE__*/React.createElement("h2", null, "Bienestar que se construye d\xEDa a d\xEDa."), /*#__PURE__*/React.createElement("p", {
    className: "pdp-bene-sub"
  }, "Una rutina diaria que acompa\xF1a tu cuerpo con constancia."), /*#__PURE__*/React.createElement("div", {
    className: "pdp-bene-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-timeline"
  }, TIMELINE.map((t, i) => /*#__PURE__*/React.createElement("div", {
    className: "pdp-tl-item",
    key: i,
    style: {
      transitionDelay: i * 80 + 'ms'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "pill"
  }, t.pill), /*#__PURE__*/React.createElement("h3", null, t.t), /*#__PURE__*/React.createElement("ul", {
    className: "pdp-tl-list"
  }, t.items.map((it, j) => /*#__PURE__*/React.createElement("li", {
    key: j
  }, it))))), /*#__PURE__*/React.createElement("div", {
    className: "pdp-howto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-howto-ico"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "20",
    height: "20",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10h12l-1 9a2 2 0 0 1-2 1.8H9A2 2 0 0 1 7 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10l2-4h12l2 4"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, "C\xF3mo tomarlo"), /*#__PURE__*/React.createElement("p", null, "Disuelve una porci\xF3n (1 scoop) en 200 ml de agua y mezcla 15\u201320 segundos. Una vez al d\xEDa, con o sin alimentos.")))), /*#__PURE__*/React.createElement("div", {
    className: "pdp-bene-side"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-bene-quote"
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, /*#__PURE__*/React.createElement("a", { href: "/pages/about", style: { color: "inherit" } }, "Por qu\xE9 creamos AUREA®")), /*#__PURE__*/React.createElement("blockquote", null, "El bienestar no se trata de hacer m\xE1s, sino de hacer bien lo esencial. Todos los d\xEDas."), /*#__PURE__*/React.createElement("cite", null, "\u2014 Eduardo G\xF3mez | Co-Fundador")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-bene-row2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-video pdp-bene-micro"
  }, /*#__PURE__*/React.createElement("video", {
    src: "https://cdn.shopify.com/videos/c/o/v/4511bb995c8e4999a5e582129c9a43c9.mp4",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    className: "pdp-bene-vid"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-bene-hand"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/Mujerbebiednoaurea.png?v=1784306393",
    alt: "Bienestar en calma"
  })))))));
}

/* --- Fórmula 20 activos --- */
function SealIco({
  type
}) {
  const p = {
    viewBox: '0 0 24 24',
    width: 22,
    height: 22,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  };
  switch (type) {
    case 'flask':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M9 3v6l-4.5 8A2 2 0 0 0 6.3 20h11.4a2 2 0 0 0 1.8-3L15 9V3"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8 3h8M7.5 14h9"
      }));
    case 'pin':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "10",
        r: "2.5"
      }));
    case 'probiotic':
      return /*#__PURE__*/React.createElement("svg", {
        viewBox: "0 0 24 24",
        width: "30",
        height: "30",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, /*#__PURE__*/React.createElement("rect", {
        x: "8",
        y: "7",
        width: "8",
        height: "10",
        rx: "4",
        transform: "rotate(-30 12 12)"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M9 8.5 7.4 7M8 11 6 10.6M8.4 13.8l-2 .6M10.6 16l-1 1.8M13.4 16.6l.4 2M15.6 14.8l1.8 1M16.4 12l2 .2M15.4 9.4l1.8-1M13.2 7.6l.6-1.9"
      }));
    case 'leaf':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M20 4C10 4 5 9 5 17c0 0 0 3 0 3M20 4c0 10-5 15-13 15"
      }));
    case 'wheat':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M12 22V8M12 8c0-2-1.5-4-4-4 0 2 1.5 4 4 4zM12 8c0-2 1.5-4 4-4 0 2-1.5 4-4 4zM12 14c0-2-1.5-3.5-4-3.5 0 2 1.5 3.5 4 3.5zM12 14c0-2 1.5-3.5 4-3.5 0 2-1.5 3.5-4 3.5z"
      }));
    case 'sprout':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M12 20V10"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M12 12C9 12 5 11 5 7c4 0 7 1 7 5M12 10c3 0 7-1 7-5-4 0-7 1-7 5"
      }));
    case 'shield':
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("path", {
        d: "M12 3l7 2.5V11c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V5.5z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M9 12l2 2 4-4.5"
      }));
    default:
      return /*#__PURE__*/React.createElement("svg", p, /*#__PURE__*/React.createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8"
      }));
  }
}
function PdpFormula() {
  const [open, setOpen] = React.useState(-1);
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-formula",
    id: "formula"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-formula-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-formula-head"
  }, /*#__PURE__*/React.createElement("h2", null, "20 activos, una sola f\xF3rmula."), /*#__PURE__*/React.createElement("a", {
    href: "/pages/ingredientes"
  }, "Ver ingredientes \u2192")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-formula-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-formula-img"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_6_jul_2026_04_44_08_p.m..png?v=1783327519",
    alt: "F\xF3rmula AUREA® 20 activos",
    className: "pdp-fixed-img"
  }), /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/qlf-labs-hd.png?v=1784128852",
    alt: "Composici\xF3n verificada por QLF Labs",
    className: "pdp-formula-qlf-below"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pdp-formula-qlf-cap"
  }, "Composici\xF3n nutricional verificada \xB7 QUIM-5019/26")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-formula-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-blends"
  }, BLENDS.map((b, i) => {
    const isOpen = open === i;
    return /*#__PURE__*/React.createElement("div", {
      className: 'pdp-blend' + (isOpen ? ' open' : ''),
      key: i
    }, /*#__PURE__*/React.createElement("button", {
      className: "pdp-blend-row",
      onClick: () => setOpen(isOpen ? -1 : i),
      "aria-expanded": isOpen
    }, /*#__PURE__*/React.createElement("span", {
      className: "pdp-blend-main"
    }, /*#__PURE__*/React.createElement("b", null, b.b), /*#__PURE__*/React.createElement("span", {
      className: "pdp-blend-sum"
    }, b.d)), /*#__PURE__*/React.createElement("span", {
      className: "pdp-blend-key"
    }, b.key), /*#__PURE__*/React.createElement("span", {
      className: "pdp-blend-pm"
    })), /*#__PURE__*/React.createElement("div", {
      className: "pdp-blend-detail",
      style: {
        maxHeight: isOpen ? '260px' : '0'
      }
    }, /*#__PURE__*/React.createElement("p", null, b.detail)));
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-seals"
  }, SEALS.map((s, i) => /*#__PURE__*/React.createElement("div", {
    className: "pdp-seal",
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: 'pdp-seal-ico' + (s.img ? ' pdp-seal-logo' : '')
  }, s.img ? /*#__PURE__*/React.createElement("img", {
    src: s.img,
    alt: s.t
  }) : /*#__PURE__*/React.createElement(SealIco, {
    type: s.ico
  })), /*#__PURE__*/React.createElement("span", null, s.t))))))));
}

/* --- Comparativa (oscuro) --- */
function PdpCompare() {
  const secRef = React.useRef(null);
  const imgRef = React.useRef(null);
  React.useEffect(() => {
    const sec = secRef.current,
      img = imgRef.current;
    if (!sec || !img) return;
    let raf = null;
    const update = () => {
      raf = null;
      const r = sec.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      if (r.bottom < 0 || r.top > vh) return;
      // progreso 0→1 mientras la sección cruza el viewport
      const prog = (vh - r.top) / (vh + r.height);
      const shift = (prog - 0.5) * 120; // px de desplazamiento vertical
      img.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.18)';
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    update();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-compare",
    ref: secRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-compare-bg",
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement("img", {
    ref: imgRef,
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/aurea_pote_vineta_reexportado.png?v=1786268842",
    alt: "",
    className: "pdp-cmp-bgimg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "pdp-compare-scrim"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-compare-in"
  }, /*#__PURE__*/React.createElement("h2", null, "C\xF3mo se compara AUREA®."), /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-aurea-strip",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-row head"
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", {
    className: "brand"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-cmp-badge"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/Frame_90.png?v=1783438396",
    alt: "AUREA®",
    style: {
      height: '44px',
      width: 'auto',
      display: 'block',
      transform: 'scale(1.95)',
      transformOrigin: 'center'
    }
  }))), /*#__PURE__*/React.createElement("span", null, "Otros")), COMPARE.map((c, i) => /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-row",
    key: i
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-label"
  }, c.t), /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-cell"
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-cmp-yes"
  }, "\u2713")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-cmp-cell"
  }, c.o === 'yes' ? /*#__PURE__*/React.createElement("span", {
    className: "pdp-cmp-yes"
  }, "\u2713") : c.o === '—' ? /*#__PURE__*/React.createElement("span", {
    className: "pdp-cmp-no"
  }, "\u2014") : /*#__PURE__*/React.createElement("span", {
    className: "pdp-cmp-oval"
  }, c.o))))))));
}

/* --- Entrega / kit --- */
function PdpDeliver() {
  const AgTick = () => /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    width: "15",
    height: "15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12.5l5 5L20 6.5"
  }));
  const kitItems = [{
    t: 'Termo mezclador AUREA®',
    d: 'Regalo de bienvenida',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/1.png?v=1783763833'
  }, {
    t: 'Vitamina D3+K2 · 30 cápsulas',
    d: 'El complemento para tus defensas',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/2.png?v=1783763833'
  }, {
    t: 'Batido AUREA® · 234 g',
    d: 'Suministro para 30 días · 30 porciones',
    img: 'https://cdn.shopify.com/s/files/1/0991/4302/4929/files/3.png?v=1783763833'
  }];
  const subItems = [{
    t: 'Entrega en 1 mes',
    d: 'Suministro para 30 días · 30 porciones'
  }, {
    t: 'Entrega en 2 meses',
    d: 'Suministro para 60 días · 60 porciones'
  }, {
    t: 'Entrega en 3 meses',
    d: 'Suministro para 90 días · 90 porciones'
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-deliver"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-deliver-in"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "pdp-deliver-title"
  }, "Tu ritual, entregado cada mes."), /*#__PURE__*/React.createElement("div", {
    className: "pdp-deliver-cards"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-deliver-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-deliver-media"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/packaging.png?v=1784469667",
    alt: "Kit de bienvenida AUREA®"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-deliver-body"
  }, /*#__PURE__*/React.createElement("h3", null, "Kit de bienvenida"), /*#__PURE__*/React.createElement("p", {
    className: "pdp-deliver-sub"
  }, "Gratis con tu primer pedido."), /*#__PURE__*/React.createElement("ul", {
    className: "pdp-deliver-list"
  }, kitItems.map((it, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-kit-thumb"
  }, it.img ? /*#__PURE__*/React.createElement("img", {
    src: it.img,
    alt: it.t
  }) : /*#__PURE__*/React.createElement(AgTick, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, it.t), /*#__PURE__*/React.createElement("span", null, it.d))))))), /*#__PURE__*/React.createElement("div", {
    className: "pdp-deliver-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-deliver-media"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPT_Image_15_jul_2026_07_25_09_p.m..png?v=1784114726",
    alt: "Suscripci\xF3n flexible AUREA®"
  })), /*#__PURE__*/React.createElement("div", {
    className: "pdp-deliver-body"
  }, /*#__PURE__*/React.createElement("h3", null, "Suscripci\xF3n flexible"), /*#__PURE__*/React.createElement("p", {
    className: "pdp-deliver-sub"
  }, "Pedidos recurrentes, seg\xFAn tu horario."), /*#__PURE__*/React.createElement("ul", {
    className: "pdp-deliver-list"
  }, subItems.map((it, i) => /*#__PURE__*/React.createElement("li", {
    key: i
  }, /*#__PURE__*/React.createElement("span", {
    className: "pdp-cmp-yes pdp-deliver-check"
  }, "\u2713"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, it.t), /*#__PURE__*/React.createElement("span", null, it.d))))))))));
}

/* --- Testing --- */
function PdpTesting() {
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-testing"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-testing-in"
  }, /*#__PURE__*/React.createElement("h2", null, "Est\xE1ndares que van m\xE1s all\xE1 de lo m\xEDnimo."), /*#__PURE__*/React.createElement("p", {
    className: "pdp-testing-sub"
  }, "AUREA® se elabora bajo protocolos HACCP/GMP en Chile, con controles microbiol\xF3gicos en cada lote \u2014porque lo que hay (y lo que no) en tu suplemento importa."), /*#__PURE__*/React.createElement("div", {
    className: "pdp-testing-grid"
  }, TESTING.map((t, i) => /*#__PURE__*/React.createElement("div", {
    className: "pdp-test-card",
    key: i
  }, /*#__PURE__*/React.createElement(Ph, {
    id: 'pdp-test-' + i,
    label: "icono"
  }), /*#__PURE__*/React.createElement("h3", null, t.t), /*#__PURE__*/React.createElement("p", null, t.d))))));
}

/* --- Microbioma --- */
function PdpMicrobiome() {
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-micro",
    id: "microbioma"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-micro-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-micro-body"
  }, /*#__PURE__*/React.createElement("h2", null, "Todo empieza en el intestino."), /*#__PURE__*/React.createElement("p", null, "Tu cuerpo es hogar de billones de microorganismos que viven en ti y contigo. Participan en funciones esenciales: ayudan a digerir los alimentos, forman parte de tu equilibrio y contribuyen a la s\xEDntesis de vitaminas y metabolitos. Es tu microbioma. Al acompa\xF1ar tu ingesta diaria con probi\xF3ticos, prebi\xF3ticos y superfoods, AUREA® apoya este ecosistema que conecta tu digesti\xF3n con tu bienestar integral."), /*#__PURE__*/React.createElement("a", {
    className: "pdp-micro-cta",
    href: "#",
    onClick: e => {
      e.preventDefault();
      window.dispatchEvent(new Event('aurea-ciencia'));
    }
  }, "Descubrir ", /*#__PURE__*/React.createElement("span", {
    className: "pdp-micro-cta-ico"
  }, "\u25B8"))), /*#__PURE__*/React.createElement("div", {
    className: "pdp-micro-media pdp-video"
  }, /*#__PURE__*/React.createElement("video", {
    src: "https://cdn.shopify.com/videos/c/o/v/7901c99d0ebb44d59236f225db5a4dc8.mp4",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true
  }))));
}

/* --- FAQ --- */
function PdpFaq() {
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-faq"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-faq-in"
  }, /*#__PURE__*/React.createElement("h2", null, "\xBFPreguntas?", /*#__PURE__*/React.createElement("br", null), "Estamos para ayudarte."), /*#__PURE__*/React.createElement(Acc, {
    items: FAQS,
    cls: "pdp-faq-list",
    itemCls: "pdp-faq-item",
    qCls: "pdp-faq-q",
    aCls: "pdp-faq-a"
  }), "      "));
}

/* --- Prueba social / lista de espera --- */
function PdpSocial() {
  return /*#__PURE__*/React.createElement("section", {
    className: "pdp-social",
    id: "social"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-wrap pdp-social-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-circle-box"
  }, /*#__PURE__*/React.createElement("h2", null, "Entra al C\xEDrculo Aurea."), /*#__PURE__*/React.createElement("p", {
    className: "pdp-circle-sub"
  }, "Beneficios y acceso exclusivos, para quienes se cuidan cada d\xEDa."), /*#__PURE__*/React.createElement(CircleForm, null), /*#__PURE__*/React.createElement("span", {
    className: "pdp-circle-micro"
  }, done0 ? "Ya eres parte del C\xEDrculo." : "Sin ruido. Solo lo esencial."))));
}

/* --- Klaviyo · Círculo AUREA --- */
const KLAVIYO_PUBLIC_KEY = 'UT6EAk';
const KLAVIYO_LIST_ID = 'VVXmVz';
let done0 = false;
function CircleForm(){
  const KEY = 'aurea_waitlist';
  const [email, setEmail] = React.useState('');
  const [done, setDone] = React.useState(false);
  const [err, setErr] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  done0 = done;
  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)){ setErr('Ingresa un correo válido'); return; }
    setErr(''); setLoading(true);
    try{
      await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'revision':'2024-10-15' },
        body: JSON.stringify({ data:{ type:'subscription', attributes:{ profile:{ data:{ type:'profile', attributes:{ email:value } } } }, relationships:{ list:{ data:{ type:'list', id:KLAVIYO_LIST_ID } } } } })
      });
    }catch(e){}
    try{ localStorage.setItem(KEY, value); }catch(e){}
    setLoading(false); setEmail(''); setDone(true);
    setTimeout(() => setDone(false), 3000);
  };
  if(done) return /*#__PURE__*/React.createElement("div", { className:"pdp-circle-done" }, "Listo. Te escribiremos pronto.");
  return /*#__PURE__*/React.createElement("form", { className:"pdp-circle-form", onSubmit: submit },
    /*#__PURE__*/React.createElement("input", { type:"email", className:"pdp-circle-input", placeholder:"tu correo", "aria-label":"Tu correo", value: email, onChange: e => setEmail(e.target.value), required: true }),
    /*#__PURE__*/React.createElement("button", { type:"submit", className:"btn btn-gold pdp-circle-btn", disabled: loading }, loading ? 'Enviando…' : 'Unirme al Círculo'),
    err ? /*#__PURE__*/React.createElement("span", { className:"pdp-circle-err" }, err) : null
  );
}

/* --- Barra sticky --- */
function PdpSticky() {
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: 'pdp-sticky' + (show ? ' show' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-sticky-in"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-sticky-thumb"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0991/4302/4929/files/ChatGPTImage2jul2026_08_24_07p.m..png?v=1783006786",
    alt: "Batido AUREA®"
  })), /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("b", null, "Superfood Aurea")), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-gold pdp-sticky-cta",
    href: "#",
    onClick: aureaCheckout
  }, "Empezar mi rutina")));
}

/* --- Footer --- */
function PdpFooter() {
  return /*#__PURE__*/React.createElement("footer", {
    className: "pdp-foot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pdp-foot-in"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "statement"
  }, "Bienestar diario formulado en Chile.")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-foot-cols"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Producto"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "#top"
  }, "El batido")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "#pilares"
  }, "Beneficios")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/ingredientes"
  }, "Ingredientes")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Ciencia"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "#ciencia"
  }, "La f\xF3rmula")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/about"
  }, "Nosotros")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Ayuda"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/preguntas-frecuentes"
  }, "Preguntas frecuentes")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/contact"
  }, "Contacto")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/envios-y-despacho"
  }, "Env\xEDos")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/cambios-y-devoluciones"
  }, "Cambios")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Legal"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/terminos-y-condiciones"
  }, "T\xE9rminos y condiciones")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/politica-suscripcion"
  }, "Pol\xEDtica de suscripci\xF3n")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/pages/politicas-de-privacidad"
  }, "Privacidad")))))), /*#__PURE__*/React.createElement("div", {
    className: "pdp-foot-in"
  }, /*#__PURE__*/React.createElement("p", {
    className: "disc"
  }, "Suplemento alimentario. Su uso no es recomendable para consumo por menores de 8 a\xF1os, embarazadas y nodrizas, salvo indicaci\xF3n profesional competente. No reemplaza a una alimentaci\xF3n balanceada. Elaborado y envasado en l\xEDneas que tambi\xE9n procesan nueces, man\xED, soya, gluten y derivados del pescado. Res. SEREMI R.M. de Salud N\xB01613366774. Elaborado por Laboratorio Natural Fuchslocher SpA. Comercializado por Grupo GC SpA."), /*#__PURE__*/React.createElement("p", {
    className: "disc"
  }, "\xA9 2026 Aurea\xAE.")), /*#__PURE__*/React.createElement("div", {
    className: "pdp-wordmark",
    role: "img",
    "aria-label": "AUREA®"
  }));
}
function PdpApp() {
  useReveal();
  const [cienciaOpen, setCienciaOpen] = React.useState(false);
  React.useEffect(() => {
    const h = () => setCienciaOpen(true);
    window.addEventListener('aurea-ciencia', h);
    return () => window.removeEventListener('aurea-ciencia', h);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PdpNav, null), /*#__PURE__*/React.createElement("main", null, /*#__PURE__*/React.createElement(PdpHero, null), /*#__PURE__*/React.createElement(PdpPillars, null), /*#__PURE__*/React.createElement(PdpScience, null), /*#__PURE__*/React.createElement(PdpBenefits, null), /*#__PURE__*/React.createElement(PdpFormula, null), /*#__PURE__*/React.createElement(PdpCompare, null), /*#__PURE__*/React.createElement(PdpDeliver, null), /*#__PURE__*/React.createElement(PdpMicrobiome, null), /*#__PURE__*/React.createElement(PdpFaq, null)), /*#__PURE__*/React.createElement("div", {
    className: "pdp-outro"
  }, /*#__PURE__*/React.createElement("video", {
    className: "pdp-outro-bg",
    autoPlay: true,
    loop: true,
    muted: true,
    playsInline: true,
    src: "https://cdn.shopify.com/videos/c/o/v/3abbfae592064191aa2a7ba48763e4c0.mp4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "pdp-outro-scrim",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(PdpSocial, null), /*#__PURE__*/React.createElement(PdpFooter, null)), /*#__PURE__*/React.createElement(PdpSticky, null), /*#__PURE__*/React.createElement(AureaCiencia, {
    open: cienciaOpen,
    onClose: () => setCienciaOpen(false)
  }));
}

/* --- Experiencia inmersiva: La Ciencia AUREA® --- */
const CIENCIA_CHAPTERS = [{
  key: "microbioma",
  eyebrow: "38 billones de microbios",
  title: ["Tu cuerpo no es solo ", {
    em: "tuyo"
  }, "."],
  mode: "disperse",
  lines: ["Una fuerza invisible impulsa tu salud.", "38 billones de microorganismos viven a lo largo de tu cuerpo — de tu intestino a tu boca a tu piel.", "Juntos forman tu microbioma: una red biológica dinámica que colabora con los sistemas de tu cuerpo para regular casi cada aspecto de tu bienestar."]
}, {
  key: "gut",
  eyebrow: "El centro de todo",
  title: ["El microbioma ", {
    em: "intestinal"
  }, "."],
  mode: "gut",
  lines: ["La mayoría de tus microbios viven en tu intestino: el centro de tu microbioma.", "Desde ahí influyen en cómo piensas, sientes, te mueves, digieres e incluso envejeces.", "Refuerzan tu mucosa, sintetizan nutrientes esenciales y ayudan a mantener el tránsito en movimiento — literalmente."]
}, {
  key: "probioticos",
  eyebrow: "14 cepas seleccionadas",
  title: ["Los ", {
    em: "probióticos"
  }, "."],
  mode: "strains",
  lines: ["Cuidar tu microbioma se reduce a unos pocos principios.", "Los probióticos son cepas vivas que aportan beneficios — pero solo cuando cumplen ciertos estándares.", "La dosis importa. La cepa importa: cada una hace algo distinto.", "La diversidad importa: múltiples cepas para múltiples funciones. Y deben llegar vivas al intestino.", "Por eso AUREA® combina 14 cepas seleccionadas."]
}, {
  key: "sinbiotico",
  eyebrow: "Probióticos + prebióticos + superfoods",
  title: ["Un ", {
    em: "sinbiótico"
  }, " por fórmula."],
  mode: "blend",
  lines: ["Un probiótico, solo, es la mitad de la historia. Para prosperar, esas cepas necesitan alimento.", "Por eso AUREA® es un sinbiótico: 14 cepas probióticas junto a fibra prebiótica —inulina y fibra de bambú— que las nutre.", "Y 21 superfoods que acompañan tu ingesta diaria.", "Una sola matriz, pensada para que los activos lleguen donde importan. Todos los días."]
}, {
  key: "integral",
  eyebrow: "Bienestar integral",
  title: ["Del intestino, a ", {
    em: "todo tu cuerpo"
  }, "."],
  mode: "radiate",
  lines: ["Del intestino a la piel. Del intestino al cerebro.", "Tu microbioma influye en cómo te sientes cada día.", "Al acompañar tu rutina con probióticos, prebióticos y superfoods, AUREA® apoya el ecosistema que conecta tu digestión con tu bienestar integral.", "No es un gesto aislado. Es parte de tu día."]
}];
function AureaCiencia({
  open,
  onClose
}) {
  const canvasRef = React.useRef(null);
  const stateRef = React.useRef({
    ci: 0,
    li: 0,
    playing: false,
    timer: null,
    mode: 'disperse'
  });
  const [, force] = React.useReducer(x => x + 1, 0);
  const AUTO_MS = 5200;
  React.useEffect(() => {
    if (!open) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const prevOv = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const canvas = canvasRef.current,
      ctx = canvas.getContext('2d');
    let W = 0,
      H = 0,
      DPR = Math.min(window.devicePixelRatio || 1, 2),
      particles = [],
      raf = 0,
      last = performance.now();
    const st = stateRef.current;
    const COL = {
      cream: [247, 243, 234],
      oro: [217, 183, 120],
      tierra: [215, 159, 72],
      green: [138, 154, 91]
    };
    function resize() {
      W = canvas.clientWidth;
      H = canvas.clientHeight;
      canvas.width = W * DPR;
      canvas.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    function initParticles() {
      const count = Math.round(Math.min(340, Math.max(120, W * H / 3600)));
      particles = [];
      for (let i = 0; i < count; i++) {
        const ang = Math.random() * Math.PI * 2,
          r = Math.sqrt(Math.random());
        particles.push({
          i,
          ang,
          r,
          cluster: i % 6,
          x: W / 2 + (Math.random() - .5) * W,
          y: H / 2 + (Math.random() - .5) * H,
          tx: W / 2,
          ty: H / 2,
          size: 1.1 + Math.random() * 2.4,
          phase: Math.random() * Math.PI * 2,
          speed: .4 + Math.random() * .9,
          col: COL.cream.slice(),
          tcol: COL.cream.slice(),
          pop: i % 5 === 0
        });
      }
    }
    function clusterCenter(c) {
      const a = c / 6 * Math.PI * 2 - Math.PI / 2,
        rad = Math.min(W, H) * 0.24;
      return {
        x: W / 2 + Math.cos(a) * rad,
        y: H * 0.54 + Math.sin(a) * rad * 0.8
      };
    }
    function computeTarget(p) {
      const cx = W / 2,
        cy = H * 0.52,
        min = Math.min(W, H);
      switch (st.mode) {
        case "disperse":
          {
            const rx = min * 0.30,
              ry = min * 0.44;
            p.tx = cx + Math.cos(p.ang) * rx * p.r;
            p.ty = cy + Math.sin(p.ang) * ry * p.r;
            p.tcol = p.i % 7 === 0 ? COL.oro : COL.cream;
            break;
          }
        case "gut":
          {
            const rad = min * 0.17;
            p.tx = cx + Math.cos(p.ang) * rad * p.r;
            p.ty = H * 0.56 + Math.sin(p.ang) * rad * p.r * 0.9;
            p.tcol = p.i % 4 === 0 ? COL.tierra : COL.oro;
            break;
          }
        case "strains":
          {
            const cc = clusterCenter(p.cluster),
              jr = min * 0.05;
            p.tx = cc.x + Math.cos(p.ang) * jr * p.r;
            p.ty = cc.y + Math.sin(p.ang) * jr * p.r;
            p.tcol = COL.cream;
            break;
          }
        case "blend":
          {
            const t = performance.now() * 0.00018,
              rad = min * 0.10 + p.r * min * 0.20,
              a = p.ang + t * (p.i % 2 ? 1.4 : -1.1);
            p.tx = cx + Math.cos(a) * rad;
            p.ty = cy + Math.sin(a) * rad * 0.92;
            p.tcol = p.i % 2 ? COL.green : COL.oro;
            break;
          }
        case "radiate":
          {
            const rad = min * 0.12 + p.r * min * 0.52;
            p.tx = cx + Math.cos(p.ang) * rad;
            p.ty = H * 0.52 + Math.sin(p.ang) * rad * 0.95;
            p.tcol = p.i % 6 === 0 ? COL.tierra : p.i % 3 === 0 ? COL.green : COL.oro;
            break;
          }
      }
    }
    function frame(now) {
      const dt = Math.min(40, now - last);
      last = now;
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      const drift = reduce ? 0 : 1;
      for (const p of particles) {
        computeTarget(p);
        const ease = st.mode === "blend" ? 0.06 : 0.045;
        p.x += (p.tx - p.x) * ease;
        p.y += (p.ty - p.y) * ease;
        if (drift) {
          p.phase += 0.0009 * dt * p.speed;
          p.x += Math.cos(p.phase) * 0.35;
          p.y += Math.sin(p.phase * 1.3) * 0.35;
        }
        for (let k = 0; k < 3; k++) p.col[k] += (p.tcol[k] - p.col[k]) * 0.05;
        const tw = reduce ? 1 : 0.72 + 0.28 * Math.sin(p.phase * 2 + p.i);
        const a = (p.pop ? 0.9 : 0.5) * tw,
          s = p.size * (p.pop ? 1.5 : 1);
        const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, s * 3.4);
        g.addColorStop(0, `rgba(${p.col[0] | 0},${p.col[1] | 0},${p.col[2] | 0},${a})`);
        g.addColorStop(1, `rgba(${p.col[0] | 0},${p.col[1] | 0},${p.col[2] | 0},0)`);
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(p.x, p.y, s * 3.4, 0, Math.PI * 2);
        ctx.fill();
      }
      if ((st.mode === "disperse" || st.mode === "radiate") && !reduce) {
        ctx.lineWidth = 0.6;
        const maxD = Math.min(W, H) * 0.11,
          maxD2 = maxD * maxD;
        for (let a = 0; a < particles.length; a += 2) {
          const p = particles[a];
          for (let b = a + 2; b < particles.length; b += 6) {
            const q = particles[b];
            const dx = p.x - q.x,
              dy = p.y - q.y,
              d2 = dx * dx + dy * dy;
            if (d2 < maxD2) {
              const al = (1 - d2 / maxD2) * 0.10;
              ctx.strokeStyle = `rgba(217,183,120,${al})`;
              ctx.beginPath();
              ctx.moveTo(p.x, p.y);
              ctx.lineTo(q.x, q.y);
              ctx.stroke();
            }
          }
        }
      }
      ctx.globalCompositeOperation = 'source-over';
      raf = requestAnimationFrame(frame);
    }
    resize();
    initParticles();
    raf = requestAnimationFrame(frame);
    const onResize = () => {
      resize();
      initParticles();
    };
    window.addEventListener('resize', onResize);
    st.mode = CIENCIA_CHAPTERS[st.ci].mode;
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', onResize);
      clearTimeout(st.timer);
      document.body.style.overflow = prevOv;
    };
  }, [open]);
  const st = stateRef.current;
  const isEnd = () => st.ci === CIENCIA_CHAPTERS.length - 1 && st.li === CIENCIA_CHAPTERS[st.ci].lines.length - 1;
  const scheduleAuto = () => {
    clearTimeout(st.timer);
    if (st.playing && !isEnd()) st.timer = setTimeout(() => next(), AUTO_MS);
    if (isEnd()) {
      st.playing = false;
    }
  };
  const loadChapter = (idx, resetLine = true) => {
    st.ci = idx;
    if (resetLine) st.li = 0;
    st.mode = CIENCIA_CHAPTERS[idx].mode;
    force();
  };
  const next = () => {
    const c = CIENCIA_CHAPTERS[st.ci];
    if (st.li < c.lines.length - 1) {
      st.li++;
    } else if (st.ci < CIENCIA_CHAPTERS.length - 1) {
      st.ci++;
      st.li = 0;
      st.mode = CIENCIA_CHAPTERS[st.ci].mode;
    } else {
      st.playing = false;
    }
    force();
    scheduleAuto();
  };
  const prev = () => {
    if (st.li > 0) {
      st.li--;
    } else if (st.ci > 0) {
      st.ci--;
      st.li = CIENCIA_CHAPTERS[st.ci].lines.length - 1;
      st.mode = CIENCIA_CHAPTERS[st.ci].mode;
    }
    force();
    scheduleAuto();
  };
  const play = () => {
    if (isEnd()) {
      loadChapter(0);
    }
    st.playing = true;
    force();
    scheduleAuto();
  };
  const pause = () => {
    st.playing = false;
    clearTimeout(st.timer);
    force();
  };
  const toggle = () => st.playing ? pause() : play();
  const goto = i => {
    pause();
    loadChapter(i);
  };
  React.useEffect(() => {
    if (!open) return;
    const onKey = e => {
      if (e.key === 'Escape') onClose();else if (e.key === 'ArrowRight') {
        pause();
        next();
      } else if (e.key === 'ArrowLeft') {
        pause();
        prev();
      } else if (e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  React.useEffect(() => {
    if (!open) return;
    const st = stateRef.current;
    st.ci = 0;
    st.li = 0;
    st.mode = CIENCIA_CHAPTERS[0].mode;
    st.playing = true;
    force();
    clearTimeout(st.timer);
    st.timer = setTimeout(() => next(), AUTO_MS);
  }, [open]);
  if (!open) return null;
  const c = CIENCIA_CHAPTERS[st.ci];
  const plain = t => t.map(x => typeof x === 'string' ? x : x.em).join('');
  const num = String(st.ci + 1).padStart(2, '0');
  return /*#__PURE__*/React.createElement("div", {
    className: "ac-stage",
    role: "dialog",
    "aria-modal": "true",
    "aria-label": "La Ciencia AUREA®"
  }, /*#__PURE__*/React.createElement("canvas", {
    className: "ac-field",
    ref: canvasRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "ac-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ac-pill"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5c-2-1.5-5-1.5-7 0v13c2-1.5 5-1.5 7 0 2-1.5 5-1.5 7 0V5c-2-1.5-5-1.5-7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5v13"
  })), /*#__PURE__*/React.createElement("span", null, "Cap\xEDtulo ", st.ci + 1)), /*#__PURE__*/React.createElement("div", {
    className: "ac-top-right"
  }, /*#__PURE__*/React.createElement("button", {
    className: "ac-icon",
    onClick: () => {
      pause();
      loadChapter(0);
    },
    "aria-label": "Reiniciar"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12a8 8 0 1 1 2.3 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-4h4"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "ac-icon",
    onClick: onClose,
    "aria-label": "Cerrar"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6l12 12M18 6L6 18"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: 'ac-center show',
    key: st.ci
  }, /*#__PURE__*/React.createElement("div", {
    className: "ac-eyebrow"
  }, c.eyebrow), /*#__PURE__*/React.createElement("h1", {
    className: "ac-title"
  }, c.title.map((t, i) => typeof t === 'string' ? /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, t) : /*#__PURE__*/React.createElement("span", {
    className: "em",
    key: i
  }, t.em)))), /*#__PURE__*/React.createElement("div", {
    className: "ac-caption"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ac-line in",
    key: st.ci + '-' + st.li
  }, c.lines[st.li]), /*#__PURE__*/React.createElement("div", {
    className: "ac-prog"
  }, num)), /*#__PURE__*/React.createElement("div", {
    className: "ac-tap left",
    onClick: () => {
      pause();
      prev();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "ac-tap right",
    onClick: () => {
      pause();
      next();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "ac-nav"
  }, /*#__PURE__*/React.createElement("button", {
    className: "ac-play",
    onClick: toggle,
    "aria-label": "Reproducir"
  }, st.playing ? /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5h3v14H7zM14 5h3v14h-3z"
  })) : /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 5v14l11-7z"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "ac-track"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ac-nodewrap"
  }, CIENCIA_CHAPTERS.map((ch, idx) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: idx
  }, idx > 0 && /*#__PURE__*/React.createElement("div", {
    className: "ac-seg"
  }), /*#__PURE__*/React.createElement("div", {
    className: 'ac-node' + (idx === st.ci ? ' active' : '') + (idx < st.ci ? ' done' : ''),
    onClick: () => goto(idx),
    role: "button",
    "aria-label": 'Capítulo ' + (idx + 1)
  })))), /*#__PURE__*/React.createElement("div", {
    className: "ac-now"
  }, /*#__PURE__*/React.createElement("span", {
    className: "ch"
  }, num), plain(c.title).replace(/\.$/, '')))));
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(PdpApp, null));
})();